import withProtectedRoute from "src/features/auth/components/withProtectedRoute";
import { ORGANIZATION_CRUD_GROUP } from "src/features/groups/groups";
import EmployeeBulkRandomCreateForm from "../components/EmployeeBulkRandomCreateForm";

export default withProtectedRoute(
  EmployeeBulkRandomCreateForm,
  "/dashboard",
  ORGANIZATION_CRUD_GROUP
);
